import React, { useCallback } from 'react';
import { Box, Typography, Button } from '@material-ui/core';

import useStyles from './styles';

const ProductError = ({ error }) => {
  const classes = useStyles();

  const handleClickRetry = useCallback(() => {
    const callback = function callback() {
      window.location.reload(true);
    };
    window.parent.postMessage({ action: String(callback), data: false }, '*');
  }, []);

  return (
    <Box className={classes.container}>
      <Typography variant="subtitle1">{error}</Typography>
      <Button className="btn-retry" onClick={handleClickRetry}>
        Tentar novamente
      </Button>
    </Box>
  );
};
export default ProductError;
